import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Customers, EntityType } from '../../entity/entity.types';
import { fetchLawFirmCustomers } from '../lawFirm.api';
import { EnterprisesRepresentedByLawFirm } from './EnterprisesRepresentedByLawFirm';
import {
  CustomersTypologies,
  CompanySizeTypologies,
} from '../../entity/charts/typologies';
import { UserContextType } from '../../user/user.types';

type Props = {
  lawOfficeIdGroup: string;
  name: string;
  loggedIn: UserContextType['loggedIn'];
  decisionCount: number;
};

type State = {
  customers: Customers;
  shouldDisplay: boolean;
};

export class LawFirmClients extends React.Component<Props, State> {
  state: State = {
    customers: {
      typologies: {},
      enterprisesSizes: {},
      enterprisesSectors: {},
      sizes: {
        typologiesTotalSubset: 0,
        enterprisesSizesTotalSubset: 0,
        enterprisesSectorsTotalSubset: 0,
      },
    },
    shouldDisplay: false,
  };

  id = 'lawFirm-clients';

  async componentDidMount() {
    const customers = (await fetchLawFirmCustomers(this.props.lawOfficeIdGroup))
      .data;
    this.setState({ customers }, () => {
      if (
        customers.sizes.typologiesTotalSubset > 0 ||
        customers.sizes.enterprisesSizesTotalSubset > 0 ||
        customers.sizes.enterprisesSectorsTotalSubset > 0
      ) {
        this.displaySection();
      }
    });
  }

  displaySection = () => {
    this.setState({ shouldDisplay: true }, () => {
      window.dispatchEvent(new CustomEvent('createNav', { detail: this.id }));
    });
  };

  render() {
    const { lawOfficeIdGroup, name, loggedIn, decisionCount } = this.props;
    const { shouldDisplay, customers } = this.state;
    const entityInfos: {
      decisionCount: number;
      entityType: EntityType;
      entityId: string;
      entityName: string;
    } = {
      entityId: lawOfficeIdGroup,
      entityName: name,
      entityType: 'lawFirm',
      decisionCount,
    };
    return (
      <>
        {shouldDisplay && (
          <h2 id={this.id} className="entity__section-title">
            <FormattedMessage id="law-firm/page/LawFirmClients.tsx/1" /> {name}
          </h2>
        )}
        {customers.sizes.typologiesTotalSubset > 0 && (
          <CustomersTypologies customers={customers} {...entityInfos} />
        )}
        {loggedIn && (
          <EnterprisesRepresentedByLawFirm
            lawOfficeIdGroup={lawOfficeIdGroup}
            name={name}
            displaySection={this.displaySection}
            decisionCount={decisionCount}
          />
        )}
        {customers.sizes.enterprisesSizesTotalSubset > 0 && (
          <CompanySizeTypologies customers={customers} {...entityInfos} />
        )}
        {/* {customers.sizes.enterprisesSectorsTotalSubset > 0 && (
          <CompanySectorTypologies customers={customers} {...entityInfos} />
        )} */}
      </>
    );
  }
}
